export enum ContainerTypeEnum {
    'container' = 'container',
    'cassette' = 'cassette',
    'trailer' = 'trailer',
    'miscellaneous' = 'miscellaneous',
}
